import { stateConstants, commonConstants } from "../_constants";
import { apiCall } from "../_helpers";
import { appNotification } from "../_components";

const {
  GET_ALL_STATES_START,
  GET_ALL_STATES_SUCCESS,
  GET_ALL_STATES_FAILED,
  ADD_STATE_START,
  ADD_STATE_END,
  ADD_STATE_FAILED,
  VIEW_STATE_START,
  VIEW_STATE_SUCCESS,
  VIEW_STATE_FAILED,
  EDIT_STATE_START,
  EDIT_STATE_END,
  EDIT_STATE_SUCCESS,
  EDIT_STATE_FAILED,
} = stateConstants;

const { SUCCESSFUL_CODE, GLOBAL_LOADING_START, GLOBAL_LOADING_ENDED } =
  commonConstants;

const TEMP_BASE_URL = "https://automated-terminal-registration.k8.isw.la";

const getAllStates = () => {
  return (dispatch) => {
    dispatch({ type: GET_ALL_STATES_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/state/all`;
    apiCall
      .get(url)
      .then((response) => {
        const { status, message, content } = response.data;

        if (status !== SUCCESSFUL_CODE) {
          const error = {
            errorMessage: message,
          };
          dispatch({ type: GET_ALL_STATES_FAILED, payload: error });
          dispatch({ type: GLOBAL_LOADING_ENDED });
          return;
        }
        dispatch({
          type: GET_ALL_STATES_SUCCESS,
          payload: content,
        });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        dispatch({ type: GET_ALL_STATES_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      });
  };
};

const viewState = (id, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: VIEW_STATE_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/state/find?code=${id}`;
    apiCall
      .get(url)
      .then((response) => {
        const content = response.data;
        onSuccessCallback();
        dispatch({ type: VIEW_STATE_SUCCESS, payload: content });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      })
      .catch((error) => {
        const payload = {
          errorMessage: `This was caused by ${error.message} Please try again`,
        };
        appNotification(
          payload.errorMessage,
          "Unable to get State's Details",
          "error"
        );
        dispatch({ type: VIEW_STATE_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
      });
  };
};

const createState = (data, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: ADD_STATE_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/state/create`;
    apiCall
      .post(url, data)
      .then((response) => {
        const { message, status } = response;
        if (status !== 200) {
          const data = response.response.data;
          const error = {
            errorMessage: data[0].message,
          };
          dispatch({ type: ADD_STATE_FAILED, payload: error });
          throw new Error(error.errorMessage);
        }

        if (status === 200) {
          const data = response.data;
          const { message, status } = data;
          if (status !== "00") {
            const error = {
              errorMessage: message,
            };
            dispatch({ type: ADD_STATE_FAILED, payload: error });
            throw new Error(error.errorMessage);
          } else {
            onSuccessCallback();
            dispatch({ type: EDIT_STATE_SUCCESS });
            dispatch({ type: GLOBAL_LOADING_ENDED });
            appNotification(
              "State has been created successfully",
              "State Added",
              "success"
            );
          }
        }
      })
      .catch((error) => {
        const payload = {
          errorMessage: `${error.message}. Please try again`,
        };
        dispatch({ type: ADD_STATE_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
        appNotification(payload.errorMessage, "Unable to add State", "error");
      });
  };
};

const editState = (id, data, onSuccessCallback) => {
  return (dispatch) => {
    dispatch({ type: EDIT_STATE_START });
    dispatch({ type: GLOBAL_LOADING_START });
    const url = `${TEMP_BASE_URL}/api/v1/state/update/${id}`;
    apiCall
      .put(url, data)
      .then((response) => {
        const { status, message } = response;

        if (status !== 200) {
          const data = response.response.data;
          const error = {
            errorMessage: data[0].message,
          };
          dispatch({ type: EDIT_STATE_FAILED, payload: error });
          throw new Error(error.errorMessage);
        }

        if (status === 200) {
          const data = response.data;
          const { message, status } = data;
          if (status !== "00") {
            const error = {
              errorMessage: message,
            };
            dispatch({ type: EDIT_STATE_FAILED, payload: error });
            throw new Error(error.errorMessage);
          } else {
            onSuccessCallback();
            dispatch({ type: EDIT_STATE_SUCCESS });
            dispatch({ type: GLOBAL_LOADING_ENDED });
            appNotification(
              "State has been updated successfully",
              "State Updated",
              "success"
            );
          }
        }
      })
      .catch((error) => {
        const payload = {
          errorMessage: `${error.message}. Please try again`,
        };
        dispatch({ type: EDIT_STATE_FAILED, payload });
        dispatch({ type: GLOBAL_LOADING_ENDED });
        appNotification(
          payload.errorMessage,
          "Unable to update State",
          "error"
        );
      });
  };
};

const stateActions = {
  getAllStates,
  viewState,
  createState,
  editState,
};

export default stateActions;
